import React, { FC, useMemo } from 'react';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import ExpensesGraph from './ExpensesGraph';
import ReceiptsSummary from './ReceiptsSummary';
import AccountStatus from './AccountStatus';
import VendorsList from './VendorsList';
import Shortcuts from '../../../components/Shortcuts';
import { ShortcutItem } from '../../../components/Shortcuts/types';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChecklistRtlOutlinedIcon from '@mui/icons-material/ChecklistRtlOutlined';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { Routes } from 'src/routes';
import { routingOnRouteRequest } from 'src/app/store/routingSlice';

type Props = ReturnType<typeof mapDispatchToProps>;

const DashboardContent: FC<Props> = ({ goTo }) => {
  const shortcuts: ShortcutItem[] = useMemo(
    () => [
      {
        title: 'צפה בחשבוניות של החודש הקודם',
        Icon: <ChecklistRtlOutlinedIcon fontSize="small" />,
        onClick: () => {
          goTo(Routes.Receipts);
        },
      },
      {
        title: 'הוסף תיבת דואר חדשה',
        Icon: <ForwardToInboxOutlinedIcon fontSize="small" />,
        onClick: () => {
          goTo(Routes.Inbox);
        },
      },
      {
        title: 'שאלות נפוצות',
        Icon: <HelpOutlineOutlinedIcon fontSize="small" />,
        onClick: () => {},
      },
    ],
    [goTo],
  );

  return (
    <Grid
      container
      columnSpacing={2}
      rowSpacing={1.25}
      pb={10}
      sx={{ overflowY: 'auto' }}
    >
      <Grid xs="auto">
        <ExpensesGraph />
      </Grid>
      <Grid xs="auto">
        <ReceiptsSummary />
      </Grid>
      <Grid xs="auto">
        <AccountStatus />
      </Grid>
      <Grid xs="auto">
        <VendorsList />
      </Grid>
      <Grid xs="auto">
        <Shortcuts shortcuts={shortcuts} />
      </Grid>
    </Grid>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  goTo: (path: Routes) => dispatch(routingOnRouteRequest({ path })),
});

export default connect(null, mapDispatchToProps)(DashboardContent);
